import { Form } from 'factorial-form'

import type { Item } from 'modules/processes/domain'
import {
  AssigneeStrategy,
  AssigneeTypeSubOptions,
} from 'modules/processes/lib/assigneeTypeSubOptions'

export const assigneeData = (form: Form, accessIds: number[]) => {
  switch (form.get('assignee_strategy').value) {
    case AssigneeStrategy.MANUAL_SELECTION:
      return { assigneeIds: accessIds, assigneeStrategy: AssigneeStrategy.MANUAL_SELECTION }
    case AssigneeStrategy.MANAGER:
      return { assigneeIds: [], assigneeStrategy: form.get('assignee_strategy').value }
    case AssigneeStrategy.WORKSPACE:
      return {
        assigneeIds: [+form.get('location_id').value],
        assigneeStrategy: form.get('assignee_strategy').value,
      }
    case AssigneeStrategy.TEAM_LEADS:
      return {
        assigneeIds: form.get('team_lead_team_ids').value,
        assigneeStrategy: form.get('assignee_strategy').value,
      }
    case AssigneeStrategy.TEAMS:
      return {
        assigneeIds: form.get('team_ids').value,
        assigneeStrategy: form.get('assignee_strategy').value,
      }
    default:
      return {
        assigneeIds: [],
        assigneeStrategy: form.get('assignee_strategy').value,
      }
  }
}

export const initialAssigneeStrategyResolver = (item?: Item) => {
  return item?.itemAssignee?.assigneeStrategy == AssigneeStrategy.MANAGER
    ? AssigneeStrategy.MANAGER
    : item?.itemAssignee?.assigneeStrategy
}

export const initialTeamIdsResolver = (form: Form, strategy?: string, item?: Item) => {
  if (form.get('assignee_strategy').value === AssigneeStrategy.WORKSPACE) {
    return form.get('team_ids').value
  }

  return strategy === AssigneeStrategy.TEAMS
    ? item?.itemAssignee?.assigneeIds
    : [AssigneeTypeSubOptions[AssigneeStrategy.TEAMS]([])[0]?.value]
}

export const initialLocationIdResolver = (form: Form, strategy?: string, item?: Item) => {
  if (form.get('assignee_strategy').value === AssigneeStrategy.WORKSPACE) {
    return form.get('location_id').value
  }

  return strategy === AssigneeStrategy.WORKSPACE
    ? item?.itemAssignee?.assigneeIds[0]
    : AssigneeTypeSubOptions[AssigneeStrategy.WORKSPACE]()[0]?.value
}

export const initialTeamLeadTeamsIdsResolver = (form: Form, strategy?: string, item?: Item) => {
  if (form.get('assignee_strategy').value === AssigneeStrategy.TEAM_LEADS) {
    return form.get('team_lead_team_ids').value
  }

  return strategy === AssigneeStrategy.TEAM_LEADS
    ? item?.itemAssignee?.assigneeIds
    : [AssigneeTypeSubOptions[AssigneeStrategy.TEAM_LEADS]([])[0]?.value]
}

export const initialAccessIdsResolver = (form: Form, strategy?: string, item?: Item) => {
  if (form.get('assignee_strategy').value === AssigneeStrategy.MANUAL_SELECTION) {
    return form.get('access_ids').value
  }

  return strategy === AssigneeStrategy.MANUAL_SELECTION ? item?.itemAssignee?.assigneeIds : []
}
